import type { MarginProperties } from '@iheartjane/reefer';
import { Flex, Skeleton, Typography } from '@iheartjane/reefer';
import { formatCurrency } from '@iheartjane/utils';
import type { ReactNode } from 'react';

import { useKioskSpacing } from '@jane/kiosk/hooks';

export interface LineItemProps extends MarginProperties {
  amount: number | undefined | ReactNode;
  isLoading?: boolean;
  label: ReactNode;
}

export const LineItem = ({
  amount,
  isLoading,
  label,
  ...others
}: LineItemProps) => {
  const { defaultSpacing } = useKioskSpacing({
    defaultPadSize: 4,
    defaultSize: 8,
  });
  return (
    <Flex
      alignItems="center"
      flexDirection="row"
      justifyContent="space-between"
      mb={defaultSpacing}
      {...others}
    >
      <Flex mr={32}>
        {typeof label === 'string' && (
          <Typography color="grays-dark" branded>
            {label}
          </Typography>
        )}
        {typeof label !== 'string' && label}
      </Flex>

      {(typeof amount === 'number' || typeof amount === 'undefined') && (
        <>
          {isLoading ? (
            <Skeleton.Bone width="100px" />
          ) : (
            <Typography variant="body-semibold" color="grays-dark" branded>
              {formatCurrency(amount)}
            </Typography>
          )}
        </>
      )}
      {typeof amount !== 'number' && (
        <>{isLoading ? <Skeleton.Bone width="100px" /> : amount}</>
      )}
    </Flex>
  );
};
